import React from 'react';

import { Popover } from '@headlessui/react';

import { cn } from 'lib/helpers/utility';

/**
 * @type {import('./lib/types').DisplayButtonWrapperProps}
 */
const DisplayButtonWrapper = ({
  buttonContent,
  panelContent,
  panelClassName = '',
  buttonClassName = ''
}) => {
  return (
    <Popover className="relative">
      {({ open }) => (
        <>
          <Popover.Button className={cn('p-0', buttonClassName)}>
            {buttonContent(open)}
          </Popover.Button>
          <Popover.Panel
            className={cn(
              'absolute right-0 top-11 z-[500] max-h-[576px] min-w-[300px] overflow-y-auto rounded border border-solid border-neutral-200 bg-white p-0 shadow-[0px_0px_16px_rgba(55,65,69,0.08)]',
              panelClassName
            )}>
            {panelContent()}
          </Popover.Panel>
        </>
      )}
    </Popover>
  );
};

export default DisplayButtonWrapper;
